<template>
  <v-app>
    <div class="card-body" style="position:relative">
      <div class="branding">
        <div class="brand-wrapper">
          <a href=""> <img :src="businesslogo" alt="logo" class="logo"/></a>
        </div>
        <v-card class="card-class">
          <v-card-title class="text-center title-map">
            Faites vous livrer efficacement avec la géolocalisation!
          </v-card-title>
          <v-spacer></v-spacer>
          <v-card-subtitle class="text-center subtitle-map">
            Ou souhaitez-vous être livré ?
          </v-card-subtitle>
          <div id="mappingo">
            <find-my-loc
              :showpreviousbutton="false"
              @previous="gobackward"
              @getdataloc="datafromlocation"
            ></find-my-loc>
          </div>
        </v-card>
      </div>
    </div>
  </v-app>
</template>

<script>
import FindMyLoc from "./findmyloc.vue";
import Logobusiness from "../../assets/images/logodouxgup.png";

export default {
  title: "Whichloc",
  components: {
    "find-my-loc": FindMyLoc
  },
  props: {},
  watch: {},
  data() {
    return {
      businesslogo: Logobusiness
    };
  },
  computed: {},
  watch: {},
  mounted() {},
  methods: {
    gobackward() {
      console.log("on retourne en arriere");
    },
    datafromlocation(datas) {
      console.log("on recupère les données from location===>", datas);
    }
  }
};
</script>

<style>
.linktoac {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.linktoac > a {
  margin: 20px;
}

.activaa {
  color: rgba(0, 0, 0, 0.6) !important;
  caret-color: #a81515 !important;
}
.activaa:hover {
  color: rgba(0, 0, 0, 0.6) !important;
}
.login-card .card-body {
  padding: 30px 30px 30px;
}
.card-class {
  border: 0;
  box-shadow: none;
}
</style>



// WEBPACK FOOTER //
// src/components/pieces/whichloc.vue